/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface KakaoDefaultTemplateFindElHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    createImmediate?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
    updateImmediate?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
    removeImmediate?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
    reservationBefore0?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
    reservationBefore1?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
    reservationBefore3?: {
      _id?: string;
      isRemoved?: boolean;
      type?: string;
      groupName?: string;
      kakaoTemplateHistoryID?: {
        _id?: string;
        hospitalID?: string;
        templateCode?: string;
        senderKey?: string;
        templateName?: string;
        templateMessageType?: string;
        templateEmphasizeType?: string;
        templateContent?: string;
        categoryCode?: string;
        requesterID?: string;
        modifierID?: string;
        inspectionStatus?: string;
        templateStatus?: string;
        serviceStatus?: string;
        block?: boolean;
        dormant?: boolean;
        buttons?: {
          type?: string;
          name?: string;
          link?: string;
        }[];
        quickReplies?: {
          name?: string;
          linkType?: string;
          linkAnd?: string;
          linkIos?: string;
          linkMo?: string;
          linkPc?: string;
        }[];
        comments?: {
          content?: string;
          /** @format date */
          createdAt?: string;
          status?: string;
          userName?: string;
          attachment?: {
            content?: string;
            /** @format date */
            createdAt?: string;
            status?: string;
            userName?: string;
            attachment?: {
              originalFileName?: string;
              filePath?: string;
            };
          };
        }[];
        isGroupTemplate?: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
        /** @format date */
        expiredAt?: string;
      };
      /** @format date */
      createdAt?: string;
      /** @format date */
      updatedAt?: string;
      /** @format date */
      removedAt?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type KakaoDefaultTemplateFindElHandlerData = KakaoDefaultTemplateFindElHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 카카오 기본 템플릿 조회
     *
     * @tags V3-ReservationGroup
     * @name KakaoDefaultTemplateFindElHandler
     * @summary 카카오 기본 템플릿 조회 ts
     * @request GET:/v3/api/v2reservationgroup/defaulttemplates/el/find
     * @secure
     * @response `200` `KakaoDefaultTemplateFindElHandlerData` success
     */
    kakaoDefaultTemplateFindElHandler: (params: RequestParams = {}) =>
      this.request<KakaoDefaultTemplateFindElHandlerData, any>({
        path: `/v3/api/v2reservationgroup/defaulttemplates/el/find`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
